module.exports = __webpack_public_path__ + "static/2p-2-b07edc7f568ba5e451ee1cb2d6aea1de.jpeg";